import { useEffect, useState } from "react";
import {
  getCookieConsent,
  ICookieConsent,
  STORAGE_COOKIE_CONSENT,
} from "../models/cookieConsent";

export const useCookieConsent = () => {
  const [consent, setConsent] = useState<ICookieConsent | null>(
    getCookieConsent,
  );

  useEffect(() => {
    const sync = () => setConsent(getCookieConsent());
    window.addEventListener(STORAGE_COOKIE_CONSENT, sync);
    return () => window.removeEventListener(STORAGE_COOKIE_CONSENT, sync);
  }, []);

  return {
    consent,
    hasChosen: consent !== null,
    isFunctionalAllowed: consent?.functional === true,
    isAnalyticsAllowed: consent?.analytics === true,
  };
};
